import React from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import ShareUrlPopUp from '../../../InfoPopUps/ShareUrlPopUp';
import PopOverMenu from '../../../PopOverMenu';
import {
    isClubAdminOrOwner,
    getClubNameDisplay,
    getRequestToJoinDisplayData,
} from '../../../../utils/clubs';
import { splitTitle } from '../../../../utils/formatting';

import withStatsig from '../../../hocs/withStatsig';

import { getClubInviteURL } from '../../../../utils/referrals';

import styles from '../../../../pages/ClubProfiles/club.scss';

class PlayersGroupHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requestToJoinButtonHover: false,
        };
    }

    UNSAFE_componentWillReceiveProps() {
        this.setState({
            requestToJoinButtonHover: false,
        });
    }

    componentWillUnmount() {
        if (this.banner) {
            this.banner.removeEventListener('load', this.updateBanner);
        }
    }

    render() {
        const {
            clubDetails,
            isAdminOrOwner,
            isAdminOrMember,
            menuOptions,
            onSelected,
            onCreateEventClick,
            onInvitePlayersClick,
            handleRequestToJoinClick,
            checkGate,
            featureGates,
            auth,
        } = this.props;

        const { user } = auth;
        const referralsEnabled = checkGate(featureGates.REFERRAL_SYSTEM);
        const clubInviteURL = getClubInviteURL(clubDetails, user, referralsEnabled);

        const {
            tierType,
            schoolProfile,
            name,
            memberCount,
            eventCount,
            sanctioned,
        } = clubDetails;

        const displayName = tierType && getClubNameDisplay(tierType, schoolProfile, name);
        const title = splitTitle(displayName);
        const requestToJoinDisplayData = getRequestToJoinDisplayData(clubDetails, this.state.requestToJoinButtonHover);

        return (
            <div className={`${styles.header} bb`}>
                <div className={`container`}>
                    <div className={`${styles.clubDetails}`}>
                        <div className={`${styles.flexContainer}`}>
                            <div className={`${styles.flexColumn} ${styles.detailsContainer}`}>
                                <div className="text-highlight2 text-body text-teal">Players Groups</div>
                                <h1 className={`${styles.title} d-block`}>
                                    {title.firstPart}
                                    <span
                                        className={`${sanctioned ? 'verified' : ''}`}
                                    >
                                        {title.lastPart}
                                    </span>
                                </h1>
                                <div className={`${styles.subTitle}`}>
                                    {memberCount} {memberCount === 1 ? 'Player' : 'Players'} &middot; {eventCount} {eventCount === 1 ? 'Event' : 'Events'}
                                </div>
                                <div className={`${styles.actions}`}>
                                    {isAdminOrOwner && (
                                        <React.Fragment>
                                            <button
                                                type="button"
                                                className={`btn btn-primary btn-md text-uppercase ${styles.primaryActionButton}`}
                                                onClick={onCreateEventClick}
                                            >
                                                Schedule Play
                                            </button>
                                            <button
                                                type="button"
                                                className={`btn btn-primary btn-md text-uppercase ${styles.primaryActionButton}`}
                                                onClick={onInvitePlayersClick}
                                            >
                                                Invite Players
                                            </button>
                                        </React.Fragment>
                                    )}
                                    {isAdminOrMember && requestToJoinDisplayData.showRequestToJoin && (
                                        <React.Fragment>
                                            <button
                                                type="button"
                                                className={`d-none d-md-block btn btn-primary btn-md text-uppercase ${styles.primaryActionButton} ${styles.requestToJoinButton}`}
                                                onMouseEnter={() => this.setState({ requestToJoinButtonHover: true })}
                                                onMouseLeave={() => this.setState({ requestToJoinButtonHover: false })}
                                                onClick={handleRequestToJoinClick}
                                                disabled={!requestToJoinDisplayData.requestToJoinEnabled}
                                            >
                                                {requestToJoinDisplayData.requestToJoinText}
                                            </button>
                                            <button
                                                type="button"
                                                className={`d-block d-md-none btn btn-primary btn-md text-uppercase ${styles.primaryActionButton} ${styles.requestToJoinButton} ${!requestToJoinDisplayData.requestToJoinEnabled ? `disabled ${styles.disabled}` : ''}`}
                                                onClick={(ev) => {
                                                    if (this.state.requestToJoinButtonHover === false && (ev.target.textContent === 'You\'re a Member' || ev.target.textContent === 'Following')) {
                                                        this.setState({
                                                            requestToJoinButtonHover: true,
                                                        });
                                                    } else {
                                                        handleRequestToJoinClick();
                                                    }
                                                }}
                                            >
                                                {requestToJoinDisplayData.requestToJoinText}
                                            </button>
                                        </React.Fragment>
                                    )}
                                    {isClubAdminOrOwner(clubDetails) && (
                                        <PopOverMenu
                                            anchorClass={`${styles.popOverMenuAnchor}`}
                                            horizontalEllipsis={false}
                                            menuItems={menuOptions}
                                            onSelected={onSelected}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className={`${styles.flexColumn} ${styles.shareContainer}`}>
                                <ShareUrlPopUp
                                    title="Share Club"
                                    className={`text-uppercase`}
                                    data-testid="players-group.header.share-popup"
                                    url={`${clubInviteURL}`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PlayersGroupHeader.propTypes = {
    clubDetails: PropTypes.shape({
        tierType: PropTypes.string,
        schoolProfile: PropTypes.object,
        name: PropTypes.string,
        memberCount: PropTypes.number,
        eventCount: PropTypes.number,
        sanctioned: PropTypes.bool,
        id: PropTypes.string,
    }).isRequired,
    isAdminOrOwner: PropTypes.bool.isRequired,
    isAdminOrMember: PropTypes.bool.isRequired,
    menuOptions: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    })).isRequired,
    onSelected: PropTypes.func.isRequired,
    onCreateEventClick: PropTypes.func.isRequired,
    onInvitePlayersClick: PropTypes.func.isRequired,
    handleRequestToJoinClick: PropTypes.func.isRequired,
    checkGate: PropTypes.func.isRequired,
    featureGates: PropTypes.shape({
        REFERRAL_SYSTEM: PropTypes.string,
    }).isRequired,
    auth: PropTypes.shape({
        user: PropTypes.object,
    }).isRequired,
};

export default withRouter(withStatsig(PlayersGroupHeader));
